import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'filesize' })
export class FileSizePipe implements PipeTransform {

    transform(bytes) {
        if (bytes === 0) {
            return '0 Bytes';
        } else {
            const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
            const k = 1024;
            const dm = 2;
            const i = Math.floor(Math.log(bytes) / Math.log(k));
            return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
        }
    }
}
